<template>
    <div>
      <b-progress :value="this.step" :max="this.NoOfSteps" variant="info"></b-progress>
      <div v-if="loaded">
      <component :is="stepComponent" @PageComplete="PageComplete" :DataPass='DataPass' :Type='Type' :ID='ID' :Feeds = 'Feeds' :Positions = 'Positions'/>
      <br/> 
      <b-row>
        <b-col><b-button variant="outline-dark" v-if="this.step>1" v-on:click="back">Back</b-button></b-col>
        <b-col> 
            <b-button variant="outline-info" v-if="this.stepComplete == false" v-on:click="next">Next</b-button>
            <b-button variant="outline-success" v-if="this.lastCompleted == true" v-on:click="finishWizard">Submit</b-button>
        </b-col>
      </b-row>
    

    </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";

  export default {
     props:['DataPass','Type','ID','Feeds','Positions'],
    data(){
        return{
        NoOfSteps: 5,
        step: 1,
        stepComplete: true,
        lastCompleted: null,
        userName: localStorage.getItem('fullname'),
        userID: localStorage.getItem('Nickname'),
        Location: localStorage.getItem('CurrentLocation'),
        PassedValues: [],
        feedArray: [],
        feedList: [],
        positionList: [],
        PositionArray: [],
        loaded: false,
        LookUpRequest: [],
        DeviceEUI: "",
        ProbeArray: []
        }
    },
    
    computed: {
      stepComponent() {
        this.step;
        return () => import(`@/components/CommissionWizard/COMScreen${this.step}.vue`);
      }
    },
    mounted(){
      let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeadersFeed = this.$apikeyPost;
    this.LookUpRequest = { RequestType: "PositionFeed" };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeadersFeed)
      .then((response) => {
        this.feedList = response.data.Feeds;
        this.positionList = response.data.Positions;
        for (let i = 0; i < this.feedList.length; i++) {
          var QuoteStr = this.feedList[i][0];
          this.feedArray.push({ text: this.feedList[i][1], value: QuoteStr });
        }
        for (let i = 0; i < this.positionList.length; i++) {
          var QuoteStr2 = this.positionList[i][0];
          this.PositionArray.push({text: this.positionList[i][1],value: QuoteStr2})
        }
      });
      this.Feeds = this.feedArray;
      this.Positions = this.PositionArray;
      this.loaded = true

    },

    methods: {
      next() {
         this.stepComplete = true;
        if (this.step < this.NoOfSteps){
            this.step++;
        }
        else{
            return;
        }
        
      },
      back(){
        this.step--;
      },
      PageComplete(page,data){

        if(page  == 1){         
          this.Type = data[0]
          this.ID = data[2]
          this.DeviceEUI = data[1]
          this.stepComplete = false;
        } else if (page == 2){
          this.DataPass = data
          this.stepComplete = false;
          if(data[0] == 'Router'){
            this.step = 5;
            this.stepComplete = true;
          }
        } else if (page == 3){
          this.DataPass = data
          this.stepComplete = false;
        }else if (page == 4){
          this.DataPass = data
          this.stepComplete = false;
        }else if (page == 5){
          this.DataPass = data
          this.stepComplete = false;
        }

        if (page == this.NoOfSteps){
          this.stepComplete = true;
          this.PassedValues = data;
          this.lastCompleted = true;
        }
      },
      finishWizard(){
        let RequestParam = ''
        if(this.PassedValues[0] == "C1"){
            RequestParam = "CommissionC1Submit"}
        if(this.PassedValues[0] == "O1"){
            RequestParam = "CommissionO1Submit"
        }
            
        let ProbeValues = this.PassedValues[3]
        let feedvalues = this.feedList
        let positionvalues = this.positionList
        let feednumber = ""
        let positionnumber = ""

        this.ProbeArray = []
          for (let x=0;x < ProbeValues.length;x++){

            for (let y=0;y<feedvalues.length;y++){
                if(feedvalues[y][1] == ProbeValues[x].ProbeFeed){
                  feednumber = feedvalues[y][0]
                }
            } 
            
            for (let z=0;z < positionvalues.length;z++){
                if(positionvalues[z][1] == ProbeValues[x].ProbePosition){
                  positionnumber = positionvalues[z][0]
                }
            }

            this.ProbeArray.push(
              [
              ProbeValues[x].ProbeNo.toString(),
              feednumber.toString(),
              positionnumber.toString(),
              ProbeValues[x].ProbeRecirc,
              ProbeValues[x].ProbeTag,
              ProbeValues[x].ProbeTemp,
              ProbeValues[x].ProbeFlow
              ]
          )
        }    
        this.LookUpRequest = { 
          RequestType: RequestParam,
              DeviceDict: [{
                "DeviceID": this.DeviceEUI,
                "ProbeList": this.ProbeArray,
                "InstallerName": this.userName,
                "InstallerUsername": this.userID,
                "Disclaimer": this.PassedValues[4],
                "Calibrated": 'True',
                "CommissionDate": this.PassedValues[1].CommissionDate,
                "CommissionTime": this.PassedValues[1].CommissionTime,
                "LocationNote": this.PassedValues[1].LocationNote,
                "DeptFloor": this.PassedValues[1].DeptFloor,
                "Location": this.Location
              }] 
          };
       
        if(this.PassedValues[0] == 'Router'){
            this.LookUpRequest = { 
              RequestType: "GatewayCommission",
              DeviceDict: [{
                "GatewayID": this.ID,
                "CommissionDate": this.PassedValues[1].CommissionDate,
                "CommissionTime": this.PassedValues[1].CommissionTime,
                "InstallerName": this.userName,
                "InstallerUsername": this.userID,
                "Location": this.Location,
                "LocationNote": this.PassedValues[1].LocationNote,
                "DeptFloor": this.PassedValues[1].DeptFloor,
                "PrimaryConnectionType": ""
                }] 
          };
        }  
        
        let LookUpUrl =
            "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
            this.$environment +
            "/device";
        let LookUpHeaders = this.$apikeyPost;
        let finalLookUpRequest = this.LookUpRequest

        axios
            .post(LookUpUrl, finalLookUpRequest, LookUpHeaders)
            .then((response) => {
              response
            });
        this.$emit("WizardComplete");
      }
    }
  };
  </script>